import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PulseMark } from "@/components/brand/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      try {
        if (sessionId) {
          await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        }
        window.history.replaceState(null, "", window.location.pathname);
        await checkAuth();
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, checkAuth]);

  return (
    <div className="fixed inset-0 grid place-items-center bg-pulse-navy">
      <div className="grid place-items-center rounded-2xl bg-white/5 p-6 heartbeat-anim">
        <PulseMark size={56} color="#FFFFFF" />
      </div>
    </div>
  );
}
